import {computed, Directive, ElementRef, HostBinding, inject} from '@angular/core';
import {StepAnchorDirective} from './step-anchor.directive';

@Directive({
    standalone: true,
    host: {
        class: 'step-focus-ring',
        style: 'transition: border-color 0.25s ease, box-shadow 0.25s ease',
    },
})
export class StepFocusRingDirective {
    private readonly anchor = inject(StepAnchorDirective, {optional: true});
    private readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

    private readonly borderColor = computed(() => {
        if (this.anchor === null) {
            return null;
        }
        return this.anchor.current() ? 'var(--bs-primary)' : 'transparent';
    });

    private readonly ring = computed(() =>
        this.anchor?.current() === true ? '0 0 0 1px var(--bs-primary)' : null,
    );

    private readonly edgeFill = computed(() =>
        this.anchor?.current() === true
            ? this.filledShare(this.anchor.element, this.anchor.state().travel).toString()
            : null,
    );

    @HostBinding('style.border-color')
    protected get borderColorStyle(): string | null {
        return this.borderColor();
    }

    @HostBinding('style.box-shadow')
    protected get ringStyle(): string | null {
        return this.ring();
    }

    @HostBinding('style.--step-edge-fill')
    protected get edgeFillStyle(): string | null {
        return this.edgeFill();
    }

    private filledShare(anchorElement: HTMLElement, travel: number): number {
        const step = anchorElement.getBoundingClientRect();
        const card = this.element.getBoundingClientRect();
        if (card.height === 0) {
            return 0;
        }
        const filledHeight = travel * step.height - (card.top - step.top);
        return Math.min(Math.max(filledHeight / card.height, 0), 1);
    }
}
